export const tags = {
    active: <div className="tag is-info is-light">Активный</div>,
    rejected: <div className="tag is-danger is-light">Отказал</div>,
    archived: <div className="tag is-warning is-light">Архивирован</div>,
}
